import TelaInicial from "./scenes/TelaInicial/TelaInicial";
import TelaPerguntas from './scenes/TelaPerguntas/TelaPerguntas';
import TelaAgradecimento from './scenes/TelaAgradecimento/TelaAgradecimento';

const appRoutes = [
    {
        path: `/:idLocal`,
        element: <TelaInicial />,
    },
    {
        path: '/perguntas',
        element: <TelaPerguntas />,
    },
    {
        path: '/agradecimento',
        element: <TelaAgradecimento />,
    },
  ];
  
  export default appRoutes;
  